import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";

import ClientRoutes from "./Routes";
import Invitation from "../components/common/invitation/Invitation";
import MainProducer from "../components/producer/MainProducer";
import ProducerTodos from "../components/producer/ProducerTodos";
import InvitationSelf from "../components/common/invitation/InvitationSelf";
import SelfInvitation from "../components/common/invitation/SelfInvitation";
import Invitation33 from "../components/common/invitation/Invitation33";
import UserPaymentFailed from "../components/common/payments/UserPaymentFailed";
import UserPaymentSuccess from "../components/common/payments/UserPaymentSuccess";

const ProducerSwitch = () => {
  return (
    <Switch>
      <Route
        path={ClientRoutes.Producer.main}
        component={(props) => <MainProducer {...props} />}
      />
      <Route
        path={ClientRoutes.Producer.todos}
        component={(props) => <ProducerTodos {...props} />}
      />
      <Route
        path={ClientRoutes.UnAuth.invitation}
        component={(props) => <Invitation {...props} />}
      />
      <Route
        path={ClientRoutes.UnAuth.invitation33}
        component={(props) => <Invitation33 {...props} />}
      />
      <Route
        path={ClientRoutes.UnAuth.selfInvitation}
        component={(props) => <SelfInvitation {...props} />}
      />
      <Route
        path={ClientRoutes.UnAuth.paymentFailed}
        component={(props) => <UserPaymentFailed {...props} />}
      />
      <Route
        path={ClientRoutes.UnAuth.paymentSuccess}
        component={(props) => <UserPaymentSuccess {...props} />}
      />
      <Redirect from="/" to={ClientRoutes.Producer.main} />
    </Switch>
  );
};

export default ProducerSwitch;
